export const TRIGGER_TYPE_TIMING = "Triggerable::Timing" as const;
export const TRIGGER_TYPE_DEPENDENCY = "Triggerable::Dependency" as const;

export type TimingTriggerType = typeof TRIGGER_TYPE_TIMING;
export type DependencyTriggerType = typeof TRIGGER_TYPE_DEPENDENCY;

export type TriggerType = TimingTriggerType | DependencyTriggerType;
export type OnboardingReferenceEvent = "start_date" | "immediate";
export type TimezoneType = "target_timezone" | "company_default_timezone" | "specific_timezone";
export type DayOfWeek = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";
export type TimeOfDay = string;
export type SpecificTimezone = string;
export type OffsetUnit = "day" | "week" | "month" | "specific_day";

interface CommonTimingFields {
  referenceEvent: OnboardingReferenceEvent;
  descriptor?: string;
  sortValue?: number;
  timeOfDay?: TimeOfDay;
  timezone?: string;
  timezoneType?: TimezoneType;
  specificTimezone?: SpecificTimezone;
}

interface OnEventDayTimingData extends CommonTimingFields {
  offset: 0;
  offsetUnit?: undefined;
  dayOfWeek?: undefined;
}

interface NonSpecificDayTimingData extends CommonTimingFields {
  offset: number;
  offsetUnit: "day" | "week" | "month";
  dayOfWeek?: undefined;
}

interface SpecificDayTimingData extends CommonTimingFields {
  offset: number;
  offsetUnit: "specific_day";
  dayOfWeek: DayOfWeek;
}

export type TimingTriggerData =
  | OnEventDayTimingData
  | NonSpecificDayTimingData
  | SpecificDayTimingData;

export interface TimingTrigger {
  id: string;
  type: Extract<TriggerType, "Triggerable::Timing">;
  data: TimingTriggerData;
  createdAt: Date;
  updatedAt: Date;
  sortValue: number;
}

export type DependencyTriggerData = {
  event: "task.completed";
  dependencyType: "TaskTemplate";
  dependencyId: string;
  descriptor?: string;
};

export type DependencyTrigger = {
  type: Extract<TriggerType, "Triggerable::Dependency">;
  data: DependencyTriggerData;
  sortValue: number;
};

export type Trigger = TimingTrigger | DependencyTrigger;
